import { HoneycombThemeBase } from '../types';
import { getSizeValue } from './getSizeValue';

export function getSpacingValue(theme: HoneycombThemeBase) {
    return (value: string | number) => {
        if (typeof value === 'number') {
            const spacing = value * theme.spacingUnit;
            return getSizeValue(spacing);
        }
        return value;
    };
}
